import { useEffect, useRef, useState } from "react";

import { window } from "@swa-ui/browser";
import { swaDate } from "@swa-ui/date";
import { deepEquals } from "@swa-ui/object";

import { getItem, setItem } from "../persistence";

/**
 * usePersistedState stores values into the session storage and retrieves values from the session storage.
 */

export const usePersistedState = (configuration) => {
  const { key, defaultValue, onExpiration } = configuration;
  const persistedData = getItem(key, defaultValue, configuration);
  const { value, expiry } = persistedData;
  const [state, setState] = useState(value);
  const expirationTimeout = useRef();
  const isMounted = useRef(false);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
    }
  }, []);

  useEffect(() => {
    if (isMounted.current && !deepEquals(value, state)) {
      setItem(key, state, configuration);

      window.clearTimeout(expirationTimeout.current);
      expirationTimeout.current = undefined;
    }
  }, [key, state]);

  useEffect(() => {
    if (onExpiration && expiry && !expirationTimeout.current) {
      const now = swaDate().valueOf();
      const timeRemaining = expiry - now;

      expirationTimeout.current = window.setTimeout(() => {
        onExpiration();
      }, timeRemaining);
    }
  });

  return [state, setState];
};
